import {updateObject} from '@/store/utils'
import {Module} from 'vuex'
import {PaymentState} from './types'
import {Tax} from '@/store/modules/taxes/types'
import {sumBy} from 'lodash'
import {EventProperty} from '../gtm/types'

export {PaymentState}

const initState = {
  taxIds: [],
  bankId: null,
  totalAmount: 0,
  payments: []
}

/**
 * To save payment thread state
 */
const module: Module<PaymentState, any> = {
  namespaced: true,
  state: {
    ...initState,
  },
  getters: {
    isInPayment(state) {
      return Boolean(state.totalAmount)
    },
    totalAmount(state) {
      if(state.payments.length === 0) {
        return 0
      }
      return sumBy(state.payments, 'amount')
    },
    taxIds(state) {
      return state.payments.map((payment) => payment.id || '')
    },
    taxNms(state) {
      return state.payments.map((payment) => payment.taxNm || '')
    },
    gtmInfo(state, getters): EventProperty {
      return {
        'amount': getters.totalAmount,
        'id': getters.taxIds,
        'type': getters.taxNms,
        'quantity': state.payments.length,
        'workflow': 'tax_payment',
      }
    }
  },
  mutations: {
    updateTotalAmount(state, payload: number) {
      state.totalAmount = payload
    },
    updateTaxIds(state, payload: any[]) {
      state.taxIds = payload
    },
    updateBankId(state, payload: any) {
      state.bankId = payload
    },
    updatePayments(state, payload: Tax[]) {
      state.payments = payload
    },
    clear(state) {
      updateObject(state, initState)
    },
  },
}

export default module
